import React from "react";

const SponsorshipCard = ({
  title,
  price,
  description,
  features,
  isHighlighted,
  buttonBg,
  buttonTextColor,
}) => {
  const headerBgColor = isHighlighted ? "#007BFF" : "#424242";
  const headerTextColor = isHighlighted ? "#FFFFFF" : "#FFFFFF";
  const borderColor = isHighlighted ? "#007BFF" : "#E0E0E0";

  return (
    <div
      className="services-card"
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        border: `2px solid ${borderColor}`,
        borderRadius: "8px",
        padding: "0",
        backgroundColor: "#fff",
        boxShadow: isHighlighted
          ? "0 10px 30px rgba(0, 123, 255, 0.2)"
          : "0 2px 10px rgba(0,0,0,0.1)",
        position: "relative",
        transition: "all 0.3s ease",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div
        style={{
          backgroundColor: headerBgColor,
          color: headerTextColor,
          padding: "15px 20px",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "18px",
          letterSpacing: "1px",
        }}
      >
        {title}
      </div>

      {/* Content */}
      <div style={{ padding: "30px" }}>
        {/* Price */}
        <div
          style={{
            fontSize: "42px",
            fontWeight: "bold",
            color: "#424242",
            marginBottom: "15px",
            textAlign: "center",
          }}
        >
          {price}
        </div>

        {/* Description */}
        <p
          style={{
            color: "#666",
            fontSize: "14px",
            marginBottom: "25px",
            lineHeight: "1.6",
            textAlign: "center",
          }}
        >
          {description}
        </p>

        {/* Features */}
        <div style={{ flex: "1", marginBottom: "20px" }}>
          {features.map((feature, index) => (
            <div key={index}>
              <div
                style={{
                  padding: "12px 0",
                  color: "#424242",
                  fontSize: "14px",
                }}
              >
                {feature}
              </div>
              {index < features.length - 1 && (
                <hr
                  style={{
                    border: "none",
                    borderTop: "1px solid #E0E0E0",
                    margin: "0",
                  }}
                />
              )}
            </div>
          ))}
        </div>

        {/* Button */}
        <button
          style={{
            marginTop: "10px",
            width: "100%",
            padding: "15px",
            backgroundColor: buttonBg,
            color: buttonTextColor,
            border: "none",
            borderRadius: "5px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "all 0.3s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
          }}
          onMouseOver={(e) => {
            if (isHighlighted) {
              e.target.style.backgroundColor = "#0056b3";
            } else if (buttonBg === "#FFC107") {
              e.target.style.backgroundColor = "#FFB300";
            } else {
              e.target.style.backgroundColor = "#D0D0D0";
            }
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 5px 15px rgba(0,0,0,0.2)";
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = buttonBg;
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "none";
          }}
        >
          Secure Your Spot
          <span style={{ fontSize: "18px" }}>✓</span>
        </button>
      </div>
    </div>
  );
};

export default SponsorshipCard;
